module.exports = __webpack_public_path__ + "img/student_19.d83d511e.png";